// ##############################
// // // bloguser
// #############################
var IMGDIR = process.env.REACT_APP_IMGDIR;

const bloguser = [
    {avatar: IMGDIR+"/images/blog/users/user-1.jpg", name: "Colin Taylor", position: "Social Media", age: "35"},
    {avatar: IMGDIR+"/images/blog/users/user-2.jpg", name: "Grace Turner", position: "Designer", age: "26"},
    {avatar: IMGDIR+"/images/blog/users/user-3.jpg", name: "Irene Smith", position: "Developer", age: "31"},
    {avatar: IMGDIR+"/images/blog/users/user-4.jpg", name: "Julia Vasar", position: "Admin", age: "32"},
    {avatar: IMGDIR+"/images/blog/users/user-5.jpg", name: "Evan Short", position: "Author", age: "37"},
    {avatar: IMGDIR+"/images/blog/users/user-6.jpg", name: "Fiona Vance", position: "Editor", age: "42"},
    {avatar: IMGDIR+"/images/blog/users/user-7.jpg", name: "Lily White", position: "Publisher", age: "33"},
    {avatar: IMGDIR+"/images/blog/users/user-8.jpg", name: "Leah Young", position: "Marketing", age: "25"},

]; 

export {
    bloguser, 
};
